<template>
  <el-dialog
    title="创建角色"
    :visible.sync="dialogVisible"
    width="40%"
    class="addRoleDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="addRoleDialogForm" :rules="rules" label-width="120px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="formData.roleName" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="角色描述">
            <el-input type="textarea" v-model="formData.roleNote" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        rules: {
          roleName: [
            { required: true, message: '请输入角色名称', trigger: 'blue' }
          ]
        },
        dialogVisible: false,
        formData: {}
      };
    },
    props: {
      addRoleShow: {
        type: Boolean,
        default: false
      },
      roleEditData: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    watch: {
      addRoleShow (val) {
        if (val) {
          if (this.roleEditData.id) {
            this.formData = this.roleEditData;
          }
          this.$nextTick(() => {
            this.$refs.addRoleDialogForm.clearValidate();
          });
        } else {
          this.formData = {};
        }
        this.dialogVisible = val;
      }
    },
    methods: {
      submitHandle () {
        this.$refs['addRoleDialogForm'].validate((valid) => {
          if (valid) {
            if (this.formData.id) {
              this.$emit('editHandle', this.formData);
            } else {
              this.$emit('submitHandle', this.formData);
            }
          }
        });
      },
      dialogCloseHandle () {
        this.$emit('dialogCloseHandle');
      }
    }
  };
</script>

<style lang="scss" scoped>
  .addRoleDialog{
    ::v-deep.el-dialog{
      margin-top: 20vh!important;
      .el-dialog__body{
        min-height: 240px;
      }
    }
  }
</style>
